import {
	GET_STATE_DROPDOWN,
	GET_STATE_DROPDOWN_SUCCESS,
	GET_STATE_DROPDOWN_FAIL,
	GET_STATE_DROPDOWN_RESET,
} from '../actions/getStateDropdownAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getStateDropdownReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_STATE_DROPDOWN:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_STATE_DROPDOWN_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_STATE_DROPDOWN_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_STATE_DROPDOWN_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getStateDropdownReducer;
